/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { Badge } from 'antd'
import { FC } from 'react'
import Text from './decorators/Text'
import styles from './layout.module.css'

interface CartLayoutProps {
  cartProductsCount: number
  className?: string
  copy: any
}

const CartLayout: FC<CartLayoutProps> = ({
  cartProductsCount,
  className,
  copy,
}) => {
  const { isMobile, onClickCart } = useHeaderContext()

  return isMobile ? (
    <button
      onClick={onClickCart}
      className={`${styles.buttonMobile} ${className || ''}`}
    >
      <Badge count={cartProductsCount} className={styles.cartBadge}>
        <Icon className="ph-shopping-cart" size={24} />
      </Badge>
    </button>
  ) : (
    <button
      className={`${styles.button} ${className || ''}`}
      onClick={onClickCart}
    >
      <Badge count={cartProductsCount} className={styles.cartBadge}>
        <Icon className="ph-shopping-cart" size={24} />
      </Badge>
      <Text>{copy?.cart}</Text>
    </button>
  )
}

export default CartLayout
